import reportService from '@/api/reportConfigService';
import router from '@/router/index';

const state= {
    reportList: [],
    loader: false,
    initialData: {},
    metadata: {},
    editId: null,
    newReport: {},

}
const getters = {
    getEditReport: state => state.newReport,
}
const actions = {
    async getReports({ commit,state }) {
        state.loader = true;
        const response = await reportService.getReports();
        state.loader=false
        commit('get', response.data.result)
    },
    async getInitialData({commit, state}) {
        state.loader=true
        const response = await reportService.getInitialData();
        state.loader=false
        commit('getInitialData', response.data)
    },
    async editReport({ commit }, report) {
        commit('edit', report);//response.data.result)
    },
    async addReport({ commit }, report) {
        const response = await reportService.addReport(report);
        if (response.data.status) {
            commit('addReport', response.data.result, { root: true });
        } 
        return response.data;
    },
    async updateReport({ commit }, report) {
        const response = await reportService.updateReport(state.editId, report);
        commit('updateReport', response.data.result, { root: true });
        return response.data;
    },
}
const mutations = {
    get(state, reports) {
        state.reportList = reports;
        state.filteredReports = reports;
    },
    getInitialData(state, data) {
        state.initialData = data;
    },
    edit(state, report) {
        state.editId = report.id
        state.newReport = report
        state.metadata = report.metaData ? report.metaData : {}
        router.push({ name: "addReport", params: { add: false } });
    },
    cancel(state) {
      state.metadata = {}
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}